import { Button, Modal, Progress, Tabs, Tooltip } from 'antd'
import React, {useState} from 'react'
import axiosInstance from '../../api/utils/axiosInstance';
import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { green } from '@ant-design/colors';

const ObligationDetails = ({idStrUsv, personId}) => {

    const [educationObligations, setEducationObligations] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [endOfPeriod, setEndOfPeriod] = useState();

    const fetchDataAndOpenModal = async () => {
        setIsLoading(true);
        try{
            const response = await axiosInstance.get(`/strucno-usavrsavanje/educationPoints?personId=${personId}&idStrUsv=${idStrUsv}`);
            setEducationObligations(response.data);
            setEndOfPeriod(new Date((response.data.slice(-1)[0].year).match(/\b(?<Year1>\d{4})( - (?<Year2>\d{4}))?\b/).groups.Year2).getFullYear());
            setIsModalOpen(true);
        }catch(e){
            console.log(e);
        }finally{
            setIsLoading(false);
        }
    }

    const closeModal = () => {
        setIsModalOpen(false);
    }

    const getProgress = (aquired, obligated, obligation, isTotalFlag) => {
        let status = determineSuccess(aquired, obligated, obligation, isTotalFlag);
        return( 
            <div style={{width: 170, marginRight: "20px"}}>
                <Progress size='small' 
                format={status ==='warning' ? (percent) => 
                    <Tooltip title="Višak od 'ostalih područja' ne pridonosi ispunjenju obveze">
                        <WarningOutlined style={{color:'#fa541c'}}/> 
                    </Tooltip>
                    : undefined}
                status = {status}
                strokeColor={status === 'warning' ? '#fa541c' : undefined}
                percent={ status === 'success' ? 100 : Math.floor((aquired/obligated) * 100)} />
            </div>
        )
    }

    const determineSuccess = (aquired, obligated, obligation, isTotalFlag) => {

        let currentYear = new Date().getFullYear();
        let obligationYear = obligation.year === "Trogdišnje razdoblje" ? endOfPeriod : new Date(obligation.year.match(/\b(?<Year1>\d{4})( - (?<Year2>\d{4}))?\b/).groups.Year2).getFullYear();
        if(aquired < obligated){
            if(currentYear > obligationYear){
                return 'exception';
            }
        }else{
            if(isTotalFlag){
                if(obligation.otherAreasAquired > obligation.otherAreasObligatory){
                    if(aquired - (obligation.otherAreasAquired - obligation.otherAreasObligatory) < obligated && currentYear > obligationYear){
                        return 'exception';
                    }

                    if(aquired - (obligation.otherAreasAquired - obligation.otherAreasObligatory) >= obligated){
                        return 'success'
                    }

                    return 'warning';
                }
            }
            return 'success';
        }
        return 'active';
    }

    const renderData = () => {
        return educationObligations?.map((obligation,index) => {
           return <Tabs.TabPane tab={`${obligation.year}`} key={index}>
                {index === 0 && 
                    <>
                        <div className="obligation-tab-content-wrapper">
                            Ukupno: {obligation.totalAquired} / {obligation.totalObligatory}
                            {getProgress(obligation.totalAquired, obligation.totalObligatory, obligation, true)}
                        </div>
                        <div className="obligation-tab-content-wrapper">
                            Osnovne aktivnosti: {obligation.basicAquired} / {obligation.basicObligatory}
                            {getProgress(obligation.basicAquired, obligation.basicObligatory, obligation)}
                        </div>
                        <div className="obligation-tab-content-wrapper">
                            Revizorska područja: {obligation.auditAreaAquired} / {obligation.auditAreaObligatory}
                            {getProgress(obligation.auditAreaAquired, obligation.auditAreaObligatory, obligation)}
                        </div>
                        <div className="obligation-tab-content-wrapper">
                            Računovodstvena područja: {obligation.accountingAreaAquired} / {obligation.accountingAreaObligatory}
                            {getProgress(obligation.accountingAreaAquired, obligation.accountingAreaObligatory, obligation)}
                        </div>
                        <div className="obligation-tab-content-wrapper">
                            <div>
                                Ostala područja: {obligation.otherAreasAquired}
                                <Tooltip title={`Maksimalno ${obligation.otherAreasObligatory}. Višak neće pridonositi ispunjenu ukupne obveze`}> <InfoCircleOutlined/> </Tooltip>
                            </div>
                            <div style={{ marginRight: "20px"}}>
                                <Progress size='small'
                                    percent={100}
                                    steps={obligation.otherAreasAquired >= obligation.otherAreasObligatory ? 20 : obligation.otherAreasAquired}
                                    strokeColor = {green[6]}
                                />
                            </div>
                        </div>
                    </>
                }
                {index !== 0 &&
                    <div className="obligation-tab-content-wrapper">
                        Područja s oznakom A: {obligation.areaAAquired} / {obligation.areaAObligatory}
                        {getProgress(obligation.areaAAquired ,obligation.areaAObligatory, obligation)}
                    </div>
                }
            </Tabs.TabPane>
        })
    }

  return (
    <td colSpan={2} className='obligation-btn-wrapper'>
        <Button onClick={fetchDataAndOpenModal} loading={isLoading}>Pregledaj detalje</Button>
        <Modal
            open={isModalOpen}
            onCancel={closeModal}
            onOk={closeModal}
            zIndex={9999}
            footer={[]}
            bodyStyle={{paddingTop:"50px"}}
            width={620}
        >
            <Tabs defaultActiveKey='0' >
                {renderData()}
            </Tabs>
        </Modal>
    </td>
  )
}

export default ObligationDetails